import React,{useState,useEffect,CSSProperties } from 'react'
import AboutUs from "../about-us.png"
import "../styles/about.css"
import PacmanLoader	 from "react-spinners/PacmanLoader";


const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
  marginTop:"21rem",
};




function About() {
  let [loading, setLoading] = useState(true);

    useEffect(()=>{
        setTimeout(()=>{
            setLoading(false);
        },1200)
    })
    return (
        <>
         {loading ?  <PacmanLoader color={"#feb800"} loading={true} cssOverride={override} size={25}/>
                    :
        <div className="container About">
            <div className="leftA">
            <img src={AboutUs} alt="aboutUs"/>
            </div>
            <div className="rightA">
                <h1>About me</h1>
                <p>
                I'm very ambitious front-end developer looking for a role in
                established IT company with the opportunity to work with the latest
                technologies on challenging and diverse projects.
              </p>
              <p>
                I'm quietly confident, naturally curious, and perpetually working on
                improving my chops one design problem at a time.
              </p>
             
            </div>
        </div>}
        </>
    )
}

export default About
